<!--
@创建人: lfq
@创建时间: 2020-07-05 15:14:48
@文件介绍: 路面养护规划管理
-->
<template>
    <d2-container>
        <div v-show="tableShow">
           <el-row style="margin-bottom: 20px">
               <el-col :span="4">
                                       <popover-form
                                               popoverWidth="680"
                                               :formConfig="advSearch"
                                               v-model="searchForm"
                                               @onSubmit="onSearch"
                                       ></popover-form>
               </el-col>
               <el-col :span="20">
                   <div class="text-align_right">
                       <el-button type="primary" v-if="(!tableUse.show)" @click="onAdd">新增</el-button>
                   </div>
               </el-col>
           </el-row>
            <!-- <div class="common-flex-center-end">
                                        <el-button type="primary" v-if="(!tableUse.show)" @click="onAdd">新增</el-button>
            </div> -->
            <br>
            <dynamic-table
                    :tableSet="tableSet"
                    :tableData="tableData"
                    :tableUse="tableUse"
                    :pageIndex="pageIndex"
                    :page-show="false"
                    :page-show-x= "true"
                    @goPageIndex="goPageIndex($event)"
                    :pageCount="pageCount"
                    @rowClick="onLook($event)"

            ></dynamic-table>
        </div>
        <div v-show="!tableShow">
            <div class="common-flex-center-end">
                <el-button-group>
                    <el-button
                            type="primary"
                            v-if="operationType!==3"  @click="dataSubmit">保存</el-button>
                    <el-button type="primary" @click="onBack">返回</el-button>
                </el-button-group>
            </div>
            <divider title="基本信息" />
            <dynamic-form
                    ref="dataForm"
                    :formConfig="dataFormConfig"
                    v-model="dataForm"
                    :disabled="formDisabled"
            ></dynamic-form>
            <div>
                <el-dialog :visible.sync="showRoute" width="80%" :show-close="true" custom-class="dialogStyle">
                        <routeTable class="dialog-top" :tableUse="tableRoute"></routeTable>
                </el-dialog>
            </div>
        </div>
        <template slot="footer" v-if="!tableShow">
            <billing-info :billingInfo="dataForm"></billing-info>
        </template>
    </d2-container>
</template>

<script>
    import routeTable from "@/views/basic/roadProduction/routeTable";
    export default {
        name: "index",
        components: {routeTable},
        props:{
            tableUse:{
                type:Object,
                default:()=>{
                    return{
                        show:false,
                        size:"small",
                        type:"success",
                        plain:true,
                        round:false,
                        circle:false,
                        loading:false,
                        disabled:false,
                        icon:"el-icon-finished",
                        title:"使用",
                        name:'使用'
                    }
                }
            }
        },
        data() {
            return {
                searchForm: {
                    /// 规划编码
                    planCode :'',
                    /// 规划名称
                    planName :'',
                },
                advSearch: {
                  list: [
                      {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "",
                                "customClass": "",
                                "disabled": false,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590545813",
                                "remoteOption": "option_1593590545813"
                            },
                            "name": "规划编码",
                            "key": "1593590545813",
                            "model": "planCode",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "",
                                "customClass": "",
                                "disabled": false,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590595172",
                                "remoteOption": "option_1593590595172"
                            },
                            "name": "规划名称",
                            "key": "1593590595172",
                            "model": "planName",
                            "rules": []
                        },
                  ],
                  config: {
                    labelWidth: 100,
                    labelPosition: "right",
                    size: "medium",
                    customClass: ""
                  }
                },
                tableShow:true,
                //表格
                tableSet: {
                    tableColumn: [
                        {
                            prop: "planCode",
                            label: "规划编码"
                        },
                        {
                            prop: "planName",
                            label: "规划名称"
                        },
                        {
                            prop: "aannual",
                            label: "规划年度"
                        },
                        {
                            prop: "routeCode",
                            label: "路线编码"
                        },
                        {
                            prop: "routeName",
                            label: "路线名称"
                        },
                        {
                            prop: "planType",
                            label: "规划类型",
                            type:"filter",
                            options:[{
                                value:"1",
                                label:'项目级规划'
                            },
                            {
                                value:"2",
                                label:'网级规划'
                            }]
                        },
                        {
                            prop: "sectionsDivided",
                            label: "路段划分",
                            type:"icon",
                            options:[{
                                value:"0",
                                icon:"frown-o",
                                style:"color:red;font-size:20px;"
                            },{
                                value:"1",
                                icon:"smile-o",
                                style:"color:#8ac007;font-size:20px;"
                            }]
                        },
                        {
                            prop: "preventiveMaintenance",
                            label: "预防性养护",
                            type:"icon",
                            options:[{
                                value:"0",
                                icon:"frown-o",
                                style:"color:red;font-size:20px;"
                            },{
                                value:"1",
                                icon:"smile-o",
                                style:"color:#8ac007;font-size:20px;"
                            }]
                        },
                        {
                            prop: "dailyMaintenance",
                            label: "日常养护",
                            type:"icon",
                            options:[{
                                value:"0",
                                icon:"frown-o",
                                style:"color:red;font-size:20px;"
                            },{
                                value:"1",
                                icon:"smile-o",
                                style:"color:#8ac007;font-size:20px;"
                            }]
                        },
                        {
                            prop: "repairMaintenance",
                            label: "功能性修复",
                            type:"icon",
                            options:[{
                                value:"0",
                                icon:"frown-o",
                                style:"color:red;font-size:20px;"
                            },{
                                value:"1",
                                icon:"smile-o",
                                style:"color:#8ac007;font-size:20px;"
                            }]
                        },
                        {
                            prop: "overhaulMaintenance",
                            label: "结构性修复",
                            type:"icon",
                            options:[{
                                value:"0",
                                icon:"frown-o",
                                style:"color:red;font-size:20px;"
                            },{
                                value:"1",
                                icon:"smile-o",
                                style:"color:#8ac007;font-size:20px;"
                            }]
                        }

                    ],
                    tableColBtn: [
                        {
                            show: true,
                            size: "small ",
                            type: "primary",
                            plain: true,
                            round: false,
                            circle: false,
                            loading: false,
                            disabled: false,
                            icon: "el-icon-view",
                            title: "查看",
                            name: "查看",
                            click: this.onLook
                        },
                        // {
                        //   show: this.verifyAuthority("system.gsims.PavementPlanningManagement.edit"),
                        //   size: "small ",
                        //   type: "primary",
                        //   plain: true,
                        //   round: false,
                        //   circle: false,
                        //   loading: false,
                        //   disabled: false,
                        //   icon: "el-icon-edit",
                        //   title: "编辑",
                        //   name: "编辑",
                        //   click: this.edit
                        // },
                        // {
                        //     show: this.verifyAuthority("system.gsims.mqiTestBatch.del"),
                        //     size: "small ",
                        //     type: "danger",
                        //     plain: true,
                        //     round: false,
                        //     circle: false,
                        //     loading: false,
                        //     disabled: false,
                        //     icon: "el-icon-delete",
                        //     title: "删除",
                        //     name: "删除",
                        //     click: this.del
                        // }
                    ]
                },
                tableData: [],
                pageIndex: 1,
                pageSize:10,
                pageCount: 0,
                //表单
                formDisabled:false,
                dataFormConfig:{
                    "list": [
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "自动生成",
                                "customClass": "",
                                "disabled": true,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590545813",
                                "remoteOption": "option_1593590545813"
                            },
                            "name": "规划编码",
                            "key": "1593590545813",
                            "model": "planCode",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "自动生成",
                                "customClass": "",
                                "disabled": true,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590595172",
                                "remoteOption": "option_1593590595172"
                            },
                            "name": "规划名称",
                            "key": "1593590595172",
                            "model": "planName",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": true,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "请选择",
                                "customClass": "",
                                "disabled": false,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590807819",
                                "remoteOption": "option_1593590807819",
                                "onFocus":this.routeShow
                            },
                            "name": "路线编码",
                            "key": "1593590807819",
                            "model": "routeCode",
                            "rules": [
                                {
                                    "required": true,
                                    "message": "必须填写"
                                }
                            ]
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "自动生成",
                                "customClass": "",
                                "disabled": true,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590831195",
                                "remoteOption": "option_1593590831195"
                            },
                            "name": "路线名称",
                            "key": "1593590831195",
                            "model": "routeName",
                            "rules": []
                        },
                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": false,
                                "clearable": false,
                                "placeholder": "请选择",
                                "required": true,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label":"项目级",
                                        "value": "1"
                                    },
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1593590909123",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1593590909123",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "规划类型",
                            "key": "1593590909123",
                            "model": "planType",
                            "rules": [
                                {
                                    "required": true,
                                    "message": "必须填写"
                                }
                            ]
                        },
                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": false,
                                "clearable": false,
                                "placeholder": "请选择",
                                "required": true,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label":"单年度",
                                        "value": "1"
                                    },
                                    {
                                        "label":"多年度",
                                        "value": "2"
                                    }
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1593590993741",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1593590993741",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "规划年度类型",
                            "key": "1593590993741",
                            "model": "planYearType",
                            "rules": [
                                {
                                    "required": true,
                                    "message": "必须填写"
                                }
                            ]
                        }
                    ],
                    "config": {
                        "labelWidth": 100,
                        "labelPosition": "right",
                        "size": "small",
                        "customClass": "",
                        "ui": "element",
                        "layout": "horizontal",
                        "labelCol": 3,
                        "width": "100%",
                        "hideLabel": false,
                        "hideErrorMessage": false
                    }
                },
                formConfig:{
                    "list": [
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "自动生成",
                                "customClass": "",
                                "disabled": true,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590545813",
                                "remoteOption": "option_1593590545813"
                            },
                            "name": "规划编码",
                            "key": "1593590545813",
                            "model": "planCode",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "自动生成",
                                "customClass": "",
                                "disabled": true,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590595172",
                                "remoteOption": "option_1593590595172"
                            },
                            "name": "规划名称",
                            "key": "1593590595172",
                            "model": "planName",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": true,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "请选择",
                                "customClass": "",
                                "disabled": false,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590807819",
                                "remoteOption": "option_1593590807819",
                                "onFocus":this.routeShow
                            },
                            "name": "路线编码",
                            "key": "1593590807819",
                            "model": "routeCode",
                            "rules": [
                                {
                                    "required": true,
                                    "message": "必须填写"
                                }
                            ]
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "自动生成",
                                "customClass": "",
                                "disabled": true,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590831195",
                                "remoteOption": "option_1593590831195"
                            },
                            "name": "路线名称",
                            "key": "1593590831195",
                            "model": "routeName",
                            "rules": []
                        },
                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": false,
                                "clearable": false,
                                "placeholder": "请选择",
                                "required": true,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label":"项目级",
                                        "value": "1"
                                    },
                                    {
                                        "label":"路网级",
                                        "value": "2"
                                    }
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1593590909123",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1593590909123",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "规划类型",
                            "key": "1593590909123",
                            "model": "planType",
                            "rules": [
                                {
                                    "required": true,
                                    "message": "必须填写"
                                }
                            ]
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "",
                                "customClass": "",
                                "disabled": false,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593590960444",
                                "remoteOption": "option_1593590960444"
                            },
                            "name": "规划对象",
                            "key": "1593590960444",
                            "model": "planObject",
                            "rules": []
                        },
                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": false,
                                "clearable": false,
                                "placeholder": "请选择",
                                "required": true,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label":"单年度",
                                        "value": "1"
                                    },
                                    {
                                        "label":"多年度",
                                        "value": "2"
                                    }
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1593590993741",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1593590993741",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "规划年度类型",
                            "key": "1593590993741",
                            "model": "planYearType",
                            "rules": [
                                {
                                    "required": true,
                                    "message": "必须填写"
                                }
                            ]
                        }
                    ],
                    "config": {
                        "labelWidth": 100,
                        "labelPosition": "right",
                        "size": "small",
                        "customClass": "",
                        "ui": "element",
                        "layout": "horizontal",
                        "labelCol": 3,
                        "width": "100%",
                        "hideLabel": false,
                        "hideErrorMessage": false
                    }
                },
                formConfig1:{
                    "list": [
                        {
                            "type": "date",
                            "icon": "icon-date",
                            "options": {
                                "defaultValue": "",
                                "readonly": false,
                                "disabled": true,
                                "editable": true,
                                "clearable": true,
                                "placeholder": "自动生成",
                                "startPlaceholder": "",
                                "endPlaceholder": "",
                                "type": "year",
                                "format": "yyyy",
                                "timestamp": false,
                                "required": false,
                                "requiredMessage": "",
                                "width": "",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "remoteFunc": "func_1593592139306",
                                "remoteOption": "option_1593592139306"
                            },
                            "name": "规划年度",
                            "key": "1593592139306",
                            "model": "aannual",
                            "rules": [

                            ]
                        },
                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": true,
                                "clearable": false,
                                "placeholder": "自动生成",
                                "required": false,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label": "未完成",
                                        "value": "0"
                                    },
                                    {
                                        "label": "完成",
                                        "value": "1"
                                    }
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1594455374215",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1594455374215",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "路段划分",
                            "key": "1594455374215",
                            "model": "sectionsDivided",
                            "rules": []
                        },
                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": true,
                                "clearable": false,
                                "placeholder": "自动生成",
                                "required": false,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label": "未完成",
                                        "value": "0"
                                    },
                                    {
                                        "label": "完成",
                                        "value": "1"
                                    }
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1594455374215",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1594455374215",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "预防养护",
                            "key": "1593592187391",
                            "model": "preventiveMaintenance",
                            "rules": []
                        },

                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": true,
                                "clearable": false,
                                "placeholder": "自动生成",
                                "required": false,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label": "未完成",
                                        "value": "0"
                                    },
                                    {
                                        "label": "完成",
                                        "value": "1"
                                    }
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1594455374215",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1594455374215",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "修复养护",
                            "key": "1593592195784",
                            "model": "repairMaintenance",
                            "rules": []
                        },
                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": true,
                                "clearable": false,
                                "placeholder": "自动生成",
                                "required": false,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label": "未完成",
                                        "value": "0"
                                    },
                                    {
                                        "label": "完成",
                                        "value": "1"
                                    }
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1594455374215",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1594455374215",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "日常养护",
                            "key": "1593592208696",
                            "model": "dailyMaintenance",
                            "rules": []
                        },
                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": true,
                                "clearable": false,
                                "placeholder": "自动生成",
                                "required": false,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label": "未完成",
                                        "value": "0"
                                    },
                                    {
                                        "label": "完成",
                                        "value": "1"
                                    }
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1594455374215",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1594455374215",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "功能性修复",
                            "key": "1593592222848",
                            "model": "repairMaintenance",
                            "rules": []
                        },

                        {
                            "type": "select",
                            "icon": "icon-select",
                            "options": {
                                "defaultValue": "",
                                "multiple": false,
                                "disabled": true,
                                "clearable": false,
                                "placeholder": "自动生成",
                                "required": false,
                                "requiredMessage": "",
                                "showLabel": false,
                                "width": "",
                                "options": [
                                    {
                                        "label": "未完成",
                                        "value": "0"
                                    },
                                    {
                                        "label": "完成",
                                        "value": "1"
                                    }
                                ],
                                "remote": false,
                                "remoteType": "option",
                                "remoteOption": "option_1594455374215",
                                "filterable": false,
                                "remoteOptions": [],
                                "props": {
                                    "value": "value",
                                    "label": "label"
                                },
                                "remoteFunc": "func_1594455374215",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true
                            },
                            "name": "结构性修复",
                            "key": "1593601012020",
                            "model": "overhaulMaintenance",
                            "rules": []
                        }
                    ],
                    "config": {
                        "labelWidth": 100,
                        "labelPosition": "right",
                        "size": "small",
                        "customClass": "",
                        "ui": "element",
                        "layout": "horizontal",
                        "labelCol": 3,
                        "width": "100%",
                        "hideLabel": false,
                        "hideErrorMessage": false
                    }
                },
                formConfig2:{
                    "list": [
                        {
                            "type": "date",
                            "icon": "icon-date",
                            "options": {
                                "defaultValue": "",
                                "readonly": false,
                                "disabled": false,
                                "editable": true,
                                "clearable": true,
                                "placeholder": "",
                                "startPlaceholder": "",
                                "endPlaceholder": "",
                                "type": "year",
                                "format": "yyyy",
                                "timestamp": false,
                                "required": true,
                                "requiredMessage": "",
                                "width": "",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "remoteFunc": "func_1593592139306",
                                "remoteOption": "option_1593592139306"
                            },
                            "name": "规划开始年度",
                            "key": "1593592139306",
                            "model": "planStartYear",
                            "rules": [
                                {
                                    "required": true,
                                    "message": "必须填写"
                                }
                            ]
                        },
                        {
                            "type": "date",
                            "icon": "icon-date",
                            "options": {
                                "defaultValue": "",
                                "readonly": false,
                                "disabled": false,
                                "editable": true,
                                "clearable": true,
                                "placeholder": "",
                                "startPlaceholder": "",
                                "endPlaceholder": "",
                                "type": "year",
                                "format": "yyyy",
                                "timestamp": false,
                                "required": true,
                                "requiredMessage": "",
                                "width": "",
                                "customClass": "",
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "remoteFunc": "func_1593592298389",
                                "remoteOption": "option_1593592298389"
                            },
                            "name": "规划结束年度",
                            "key": "1593592298389",
                            "model": "planEndYear",
                            "rules": [
                                {
                                    "required": true,
                                    "message": "必须填写"
                                }
                            ]
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "",
                                "customClass": "",
                                "disabled": false,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593592171625",
                                "remoteOption": "option_1593592171625"
                            },
                            "name": "路段划分",
                            "key": "1593592171625",
                            "model": "sectionsDivided",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "",
                                "customClass": "",
                                "disabled": false,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593592187391",
                                "remoteOption": "option_1593592187391"
                            },
                            "name": "预防养护",
                            "key": "1593592187391",
                            "model": "preventiveMaintenance",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "",
                                "customClass": "",
                                "disabled": false,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593592195784",
                                "remoteOption": "option_1593592195784"
                            },
                            "name": "修复养护",
                            "key": "1593592195784",
                            "model": "repairMaintenance",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "string",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "",
                                "customClass": "",
                                "disabled": false,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593592208696",
                                "remoteOption": "option_1593592208696"
                            },
                            "name": "日常养护",
                            "key": "1593592208696",
                            "model": "dailyMaintenance",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "自动生成",
                                "customClass": "",
                                "disabled": true,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593592222848",
                                "remoteOption": "option_1593592222848"
                            },
                            "name": "功能性修复",
                            "key": "1593592222848",
                            "model": "repairMaintenance",
                            "rules": []
                        },
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "requiredMessage": "",
                                "dataType": "",
                                "dataTypeCheck": false,
                                "dataTypeMessage": "",
                                "pattern": "",
                                "patternCheck": false,
                                "patternMessage": "",
                                "placeholder": "自动生成",
                                "customClass": "",
                                "disabled": true,
                                "labelWidth": 100,
                                "isLabelWidth": false,
                                "hidden": false,
                                "dataBind": true,
                                "showPassword": false,
                                "remoteFunc": "func_1593601012020",
                                "remoteOption": "option_1593601012020"
                            },
                            "name": "结构性修复",
                            "key": "1593601012020",
                            "model": "overhaulMaintenance",
                            "rules": []
                        }
                    ],
                    "config": {
                        "labelWidth": 100,
                        "labelPosition": "right",
                        "size": "small",
                        "customClass": "",
                        "ui": "element",
                        "layout": "horizontal",
                        "labelCol": 3,
                        "width": "100%",
                        "hideLabel": false,
                        "hideErrorMessage": false
                    }
                },
                initForm: {
                    /// 主键id
                    rowCode :0,
                    /// 规划编码
                    planCode :'',
                    /// 规划名称
                    planName :'',
                    /// 路线id
                    routeId :'',
                    /// 路线编码
                    routeCode :'',
                    /// 路线名称
                    routeName :'',
                    /// 规划类型 1-项目级规划；2-网级规划；
                    planType :'',
                    /// 规划对象
                    planObject :'',
                    /// 规划年度类型 1-单年度；2-多年度；
                    planYearType :'',
                    /// 规划开始年度
                    planStartYear :0,
                    /// 规划结束年度
                    planEndYear :0,
                    /// 规划年度
                    aannual :0,
                    /// 路段划分
                    sectionsDivided :'',
                    /// 预防养护
                    preventiveMaintenance :'',
                    /// 日常养护
                    dailyMaintenance :'',
                    /// 中修养护
                    repairMaintenance :'',
                    /// 大修养护
                    overhaulMaintenance:"",
                    /// 状态
                    status :'',
                    /// 创建人
                    createUser :'',
                    /// 创建人名称
                    createUserName :'',
                    /// 创建时间
                    createTime :'',
                    /// 更新人
                    updateUser :'',
                    /// 更新人名称
                    updateUserName :'',
                    /// 更新时间
                    updateTime :'',
                    /// 是否删除
                    isDelete :'',
                    /// 删除人
                    deleteUser :'',
                    /// 删除人名称
                    deleteUserName :'',
                    /// 删除时间
                    deleteTime :'',
                    /// 备用字段1
                    r1 :'',
                    /// 备用字段2
                    r2 :'',
                    /// 备用字段3
                    r3 :'',
                    /// 备用字段4
                    r4 :'',

                    /// 备用字段5

                    r5 :'',

                },
                dataForm:{
                    /// 主键id
                    rowCode :0,
                    /// 规划编码
                    planCode :'',
                    /// 规划名称
                    planName :'',
                    /// 路线id
                    routeId :'',
                    /// 路线编码
                    routeCode :'',
                    /// 路线名称
                    routeName :'',
                    /// 规划类型 1-项目级规划；2-网级规划；
                    planType :'',
                    /// 规划对象
                    planObject :'',
                    /// 规划年度类型 1-单年度；2-多年度；
                    planYearType :'',
                    /// 规划开始年度
                    planStartYear :0,
                    /// 规划结束年度
                    planEndYear :0,
                    /// 规划年度
                    aannual :0,
                    /// 路段划分
                    sectionsDivided :'',
                    /// 预防养护
                    preventiveMaintenance :'',
                    /// 日常养护
                    dailyMaintenance :'',
                    /// 中修养护
                    repairMaintenance :'',
                    /// 大修养护
                    overhaulMaintenance:"",
                    /// 状态
                    status :'',
                    /// 创建人
                    createUser :'',
                    /// 创建人名称
                    createUserName :'',
                    /// 创建时间
                    createTime :'',
                    /// 更新人
                    updateUser :'',
                    /// 更新人名称
                    updateUserName :'',
                    /// 更新时间
                    updateTime :'',
                    /// 是否删除
                    isDelete :'',
                    /// 删除人
                    deleteUser :'',
                    /// 删除人名称
                    deleteUserName :'',
                    /// 删除时间
                    deleteTime :'',
                    /// 备用字段1
                    r1 :'',
                    /// 备用字段2
                    r2 :'',
                    /// 备用字段3
                    r3 :'',
                    /// 备用字段4
                    r4 :'',

                    /// 备用字段5

                    r5 :'',

                },
                operationType:1,
                //路线弹框显示
                showRoute:false,
                tableRoute: {
                    show: true,
                    size: "mini",
                    type: "success",
                    plain: true,
                    round: false,
                    circle: false,
                    loading: false,
                    disabled: false,
                    icon: "",
                    types:"0",
                    title: "使用",
                    name: "使用",
                    click: this.useRoute
                },
            }
        },
        methods:{
            //新增
            onAdd(){
                this.tableShow = false
                this.dataForm = this.deepCopy(this.initForm)
                this.formDisabled = false
                this.operationType = 1
            },
            //分页
            goPageIndex(pageIndex,pageSize){
                this.pageIndex = pageIndex
                this.pageSize = pageSize
                let url = this.$url.routeDecision.getpmdpavementplanmanagementlist
                this.$http.postHandle("", url, {
                    ...this.searchForm,
                    pageIndex:pageIndex,
                    pageSize:pageSize
                }).then(res => {

                    this.tableData = res.data
                    this.pageCount = res.pageCount
                });
            },
            //查看
            onLook(row){
                let url = this.$url.routeDecision.getpmdpavementplanmanagementlist
                this.$http.postHandle("", url, {
                    planCode:row.planCode
                }).then(res => {
                    this.tableShow = false
                    this.dataForm = this.deepCopy(res.data[0])
                    this.dataForm.aannual =  this.dataForm.aannual.toString()
                    this.formDisabled = true
                    this.operationType = 3
                });
            },
            //查询
            onSearch(){
                let url = this.$url.routeDecision.getpmdpavementplanmanagementlist
                this.$http.postHandle("", url, {
                    ...this.searchForm,
                    pageIndex:this.pageIndex,
                    pageSize:this.pageSize
                }).then(res => {
                    this.tableData = res.data
                    this.pageCount = res.pageCount
                });
            },
            //返回
            onBack(){
                this.tableShow = true
                this.dataForm = this.deepCopy(this.initForm)
                this.formDisabled = false
            },
            //保存
            dataSubmit(){
                let url = this.$url.routeDecision.operationpavementplan
                let form = this.deepCopy(this.dataForm)
                if (form.planYearType == "2") {
                    let d_value = Number(form.planEndYear) - Number(form.planStartYear)
                    if (d_value <= 0) {
                        this.$message.error("结束年度需在开始年度之后")
                    } else if (d_value >= 10) {
                        this.$message.error("养护规划期超过10年，指导性极差，请重新输入规划年度")
                    }
                    this.$refs.dataForm.submit().then(res => {

                        let data = {
                            "pavementPlan": form
                        }
                        this.$http.postHandle("保存", url, data).then(res => {
                            this.tableShow = true
                            this.onSearch();
                        });
                    })
                }else {
                    form.aannual= (Number(this.moment().format("YYYY"))+1).toString()
                    form.planStartYear = form.aannual
                    form.planEndYear = form.aannual
                    this.$refs.dataForm.submit().then(res => {

                        let data = {
                            "pavementPlan": form
                        }
                        this.$http.postHandle("保存", url, data).then(res => {
                            this.tableShow = true
                            this.onSearch();
                        });
                    })
                }
            },
            //使用路线
            routeShow(){
                this.showRoute = true
            },
            useRoute(row,index){
                this.dataForm.routeId = row.routeId;
                this.dataForm.routeCode = row.routeCode;
                this.dataForm.routeName = row.routeName;
                this.showRoute = false
            },


        },
        created() {
            this.onSearch()
        },
        watch:{
            "dataForm.planYearType"(nv,ov){
                if(nv=="1"){
                    this.dataFormConfig = {
                        "list":[...this.formConfig.list,...this.formConfig1.list],
                        "config": {
                            "labelWidth": 100,
                            "labelPosition": "right",
                            "size": "small",
                            "customClass": "",
                            "ui": "element",
                            "layout": "horizontal",
                            "labelCol": 3,
                            "width": "100%"
                        }}


                }else{
                    this.dataFormConfig = {
                        "list":[...this.formConfig.list,...this.formConfig2.list],
                        "config": {
                            "labelWidth": 100,
                            "labelPosition": "right",
                            "size": "small",
                            "customClass": "",
                            "ui": "element",
                            "layout": "horizontal",
                            "labelCol": 3,
                            "width": "100%"
                        }}
                }
            }

        }
    }
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementPlanningManagement/index.vue"
}
</vue-filename-injector>
